// =============================================================================
//  Copyright   : 2019 semantics GmbH
//  Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 156393 $
//  Purpose     : call states APIs
// =============================================================================
// ---Third-party imports
import {put, takeEvery, call, all, select, putResolve, fork, take} from 'redux-saga/effects'

// ---Framework imports
import {has, get, isArray, size} from 'ldash'
import Api from 'uix/api'
import log from 'uix/logging'
import {Actions} from 'uix/registries'
import {loadStatesConfig, setStatesConfig, setStateMany} from './actions'
import {hashObj} from 'uix/utils'

// ---Globals
function* _loadStatesConfig({payload}) {
  let {dname, statusType} = payload
  if (isArray(statusType)) {
    statusType = ','.join(statusType)
  }
  let params = statusType ? {statusType} : {}

  let {data, error} = yield Api.get(`/${dname}/api/getStatesConfig`, params)
  if (error) {
    yield put(Actions.errorNotification({error, header: 'States: Load Error'}))
  } else if (data) {
    yield putResolve(setStatesConfig(dname, data))
  }
}

function* _setStateMany({payload}) {
  let {otids, statusType, statusValue, affectedParts} = payload

  if (!isArray(otids)) {
    otids = [otids]
  }

  let params = {otids: otids.join(','), statusType, statusValue}
  let {data, error} = yield Api.get(`/api/setStateMany`, params)
  if (error) {
    yield put(Actions.errorNotification({error, header: 'States: failed to set States'}))
  } else if (data) {
    if (size(affectedParts) > 0) {
      yield all(affectedParts.map(partName => put(Actions.reloadPartFilters(partName))))
    }
    /// XXX
  }
}

export const sagas = {
  //~ loadStatesConfig: takeEvery(loadStatesConfig, _loadStatesConfig),
  loadStatesConfig: fork(function*() {
    // serialize loading - and check whats already done
    while (true) {
      // XXX: use buffered action channel
      let action = yield take(loadStatesConfig)
      let {dname, statusType} = action.payload
      let available = yield select(root => has(root.config.states, dname))
      if (statusType) {
        available = yield select(root => has(root.config.states, `${dname}.${statusType}`))
      }
      if (!available) {
        yield _loadStatesConfig(action)
      }
    }
  }),

  setStateMany: takeEvery(setStateMany, _setStateMany),
}
